import { useState } from "react";
import {
  MiBox,
  MiButton,
  MiDetailPageHeader,
  MiList,
} from "@miplatform/components";
import { PAGINATION } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { mdiPlus } from "@mdi/js";
import { AddCityModal } from "../../../components/AddCityModal/AddCityModal";
import { useManageCitiesViewModel } from "./useManageCitiesViewModel";

export function ManageCities() {
  const { navigate } = useRouter();
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false);
  const {
    cities,
    search,
    debouncedSearch,
    setSearch,
    setCities,
    isLoading,
    getCities,
  } = useManageCitiesViewModel();

  const sections = [
    {
      fieldset: [
        {
          label: "City",
          field: "cityName",
        },
        {
          label: "County",
          field: "countyName",
        },
        {
          label: "State",
          field: "regionCode",
        },
      ],
    },
  ];

  const handleCreateDrawerOpen = () => setIsCreateDrawerOpen(true);

  const handleCreateDrawerClose = () => setIsCreateDrawerOpen(false);

  return (
    <>
      <MiDetailPageHeader
        title="Cities"
        search={search}
        onHandleSearch={(e) => setSearch(e.target.value)}
        loading={isLoading}
        actionComponent={
          <MiButton
            title="Add City"
            variant="contained"
            startIcon={{
              path: mdiPlus,
              iconSize: 0.8,
            }}
            data-testid="add-city-btn"
            onClick={handleCreateDrawerOpen}
          />
        }
      />
      <MiBox height="inherit">
        <MiList
          groupedMode
          viewType="card"
          cardProps={{
            sections,
            onClick: (item) => {
              navigate(`/settings/city-management/cities/${item.id}`);
            },
          }}
          data={cities}
          loading={isLoading}
          search={debouncedSearch}
          setSearch={setSearch}
          setData={setCities}
          dataProvider={getCities}
          paginationMode={PAGINATION.SERVER}
          groupedCriteria={(item) => item.regionCode}
        />
      </MiBox>
      <AddCityModal
        open={isCreateDrawerOpen}
        onClose={handleCreateDrawerClose}
        onCreate={(city) =>
          navigate(`/settings/city-management/cities/${city.id}`)
        }
      />
    </>
  );
}
